import { RequestNames } from 'src/constants';
import type { ReelRun } from 'src/reel-runs';
import { createAsyncAppThunk } from 'src/requests';
import type { DeviceEvent } from '../devices';

export default createAsyncAppThunk<
  null,
  { reelRuns: ReelRun[]; events: DeviceEvent[] }
>(RequestNames.UPDATE_STATUS_MAP);
